module.exports = "pegasus_template/assets/blocks/capture-4-basic.png";